module.exports = __webpack_public_path__ + "img/fossil3Img2.a24ade3b.jpg";